import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.514 0 10 4.486 10 10 0 5.513-4.486 10-10 10S0 15.513 0 10C0 4.486 4.486 0 10 0zm5.603 15.7A7.97 7.97 0 0 0 18 10c0-4.41-3.589-8-8-8s-8 3.59-8 8c0 2.23.919 4.248 2.396 5.7C5.801 14.842 7.744 14 10 14c2.257 0 4.199.841 5.603 1.7zm-9.454 1.31a7.965 7.965 0 0 0 7.702-.002C12.782 16.458 11.464 16 10 16c-1.463 0-2.782.457-3.851 1.01zM10 4c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 6c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2z"
});

var SvgProfileMajorMonotone = function SvgProfileMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgProfileMajorMonotone as S };